/**
 * Created by omero on 06-Dec-16.
 */
import { Injectable} from 'ng-metadata/core';
import {getInstitutionCode} from '../appConfig/appConfigForward';


const filter  = require('lodash/filter');
const endWith  = require('lodash/endsWith');
const replace  = require('lodash/replace');
const map  = require('lodash/map');

@Injectable()
export class FilterInstitution{


    public filterAndNormalizeData(item, values){
        function  replaceEnd(item){
            return item.replace(/\$\$I.*?(?=\$\$|$)/g,'');
        }
        var inst = getInstitutionCode();
        var include$$I = new RegExp("\\$\\$I\\s*" + inst+"\\s*(\\$.*)?$");
        var b= filter(values, function(o) {return  (o ? ((include$$I.test(o) || !o.includes("$$I"))) : true )});
        b= map(b, replaceEnd);
        return b;
    }


    public filterAndNormalizeDataFacets(item){
        var inst = getInstitutionCode();
        function  replaceEnd(elem){
            elem.displayValue  =replace(elem.value, "$$I" + inst, '');
            if(elem.label){
                elem.displayValue = elem.label;
            }
            return elem;
        }
        var b= filter(item, function(o) {return  (endWith(o.value,"$$I" + inst) || !o.value.includes("$$I")) });
        b= map(b, replaceEnd);
        return b;
    }



}


// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/filterInstitution.service.ts